import { Platform, Share } from 'react-native';

type ClipboardNavigator = {
  clipboard?: { writeText?: (value: string) => Promise<void> };
};

/**
 * Copy text for admin QR fallback. Uses browser clipboard on web; Share elsewhere.
 */
export async function copyText(text: string): Promise<'copied' | 'shared'> {
  const value = text.trim();
  if (!value) throw new Error('Nothing to copy');

  if (Platform.OS === 'web') {
    const nav = navigator as ClipboardNavigator;
    if (nav.clipboard?.writeText) {
      await nav.clipboard.writeText(value);
      return 'copied';
    }
  }

  await Share.share({ message: value });
  return 'shared';
}
